import displayName from '../tools/display-name';
import { get, post, postV2 } from '../tools/http';
import { comparer } from '../tools/comparer';
import { getImgUrl } from '../tools/uploader';
import { isoStringToYYYYMMDD } from '../tools/moment-date';
import { securityService } from '../tools/sequrity_service';
import appBaseUrl from '@/tools/appBaseUrl';

export default {
    state: {
        deletedProfile: '',
        userProfileInfo: {},
        hasLeader: false,
        telErrorMsg: '',
        userFavoriteCompetencies: [],
        dataRequestRequareFields: [],
        avatars: {
            avatar: null,
        },
        coinsData: null,
    },
    mutations: {
        setUserProfileInfo: (state, userInfo) => {
            state.userProfileInfo = userInfo;
        },
        setTelErrorMsg: (state, msg) => {
            state.telErrorMsg = msg;
        },
        updateUser: (state, updateData) => {
            Object.assign(state.userProfileInfo, updateData);
        },

        setHasLeader: (state, val) => (state.hasLeader = val),

        setFavoriteCompetencies: (state, val) =>
            (state.userFavoriteCompetencies = val),
        setDataRequestRequareFields: (state, fields) =>
            (state.dataRequestRequareFields = fields),

        deleteFavoriteCompetencies: (state, competenceId) => {
            let finder = state.userFavoriteCompetencies.findIndex(
                c => c.competenceIdInProfile == competenceId
            );
            if (finder > -1) {
                state.userFavoriteCompetencies.splice(finder, 1);
            }
        },
        addDeleteStatus: (state, deleteInfo) => {
            state.deletedProfile = deleteInfo;
        },
        setAvatar: (state, { key, url }) => {
            state.avatars[key] = url;
        },
        setCoinsData: (state, coinsData) => {
            state.coinsData = coinsData;
        },
    },
    actions: {
        async loadUserCoinsData(ctx) {
            try {
                const currentUser = await get(
                    'coins',
                    'api/Participant/current', {}, true
                );

                if (currentUser) {
                    ctx.commit('setCoinsData', currentUser);
                }
            } catch (err) {
                console.error(err);
            }
        },
        loadProfileData: async ctx => {
            if (!ctx.rootGetters.user.id) return;
            const path = `user/${ctx.rootGetters.user.id}`;
            let userProfileInfo = null;
            let userProfile = {};


            try {
                let res = await get('profile', path, { only_ids: 1 }, true);
                userProfileInfo = res.status === 'success' ? res.data : null;
            } catch (err) {
                let res = err.response.data;
                if (res.message === 'Account is deleted') {
                    securityService.signOut(`${appBaseUrl}delete-profile-message/`);
                }
            }
            try {
                await ctx.dispatch('loadUserCoinsData');
            } catch (err) {
                console.error(err);
            }

            if (userProfileInfo === null || !userProfileInfo.hasOwnProperty('info')) {
                ctx.commit('setUserProfileInfo', {});
                return;
            }

            ctx.commit('setHasLeader', userProfileInfo.info.hasOwnProperty('isLeader')
                ? userProfileInfo.info.isLeader
                : false
            );

            userProfile = { ...userProfileInfo.info };

            ctx.dispatch('loadAvatar', {
                key: 'avatar',
                url: userProfile['avatar']
                    ? userProfile['avatar'].url
                    : null,
            });

            userProfile['avatar'] = await getImgUrl(
                userProfile['avatar'] ? userProfile['avatar'].url : null,
                ctx.rootGetters.user_img_stub
            );
            userProfile['avatarOfficial'] = await getImgUrl(
                userProfile['avatarOfficial']
                    ? userProfile['avatarOfficial'].url
                    : null,
                ctx.rootGetters.user_img_stub
            );

            userProfile.dateOfBirth = isoStringToYYYYMMDD(
                userProfile.dateOfBirth
            );
            userProfile.gosSecretFrom = isoStringToYYYYMMDD(
                userProfile.gosSecretFrom
            );
            userProfile.gosSecretTo = isoStringToYYYYMMDD(
                userProfile.gosSecretTo
            );
            ctx.commit('setUserProfileInfo', userProfile);
        },

        async loadAvatar(ctx, { key, url }) {
            ctx.commit('setAvatar', {
                key,
                url: await getImgUrl(url, null),
            });
        },

        postProfileData: async (ctx, postData) => {
            const diff = comparer(ctx.state.userProfileInfo, postData);
            if (Object.keys(diff).length > 0) {
                let resultData = {};
                Object.keys(diff).forEach(key => {
                    if (key == 'userLanguages') {
                        diff[key] = diff[key].filter(obj => {
                            return !Object.keys(obj).some(key => {
                                return obj[key] === null;
                            });
                        });
                    }
                    resultData[key] = diff[key];
                });

                const res = await postV2(
                    'profile',
                    'user/info/update',
                    resultData,
                    true,
                    { full: true, nullOnError: false }
                );

                ctx.commit('updateUser', resultData);
                return res;
            }
        },

        loadDataRequestRequareFields: async ctx => {
            let res = await get('event', 'participant/fields/list');
            if (res && res.fields) {
                ctx.commit('setDataRequestRequareFields', res.fields);
            }
        },

        loadFavoriteCompetencies: async ctx => {
            let userFavoriteCompetencies = [];
            userFavoriteCompetencies = await get(
                'profile',
                'competence/favorite/all'
            );
            let competences = [];
            if (userFavoriteCompetencies.competencies.length) {
                competences = await Promise.all(
                    userFavoriteCompetencies.competencies.map(async c => {
                        let comp = await ctx.dispatch(
                            'loadCompetenceById',
                            c.foreignCompetenceId
                        );
                        return {
                            ...comp,
                            key: c.key,
                            competenceIdInProfile: c.id,
                        };
                    })
                );
            }
            ctx.commit('setFavoriteCompetencies', competences);
        },

        addFavoriteCompetence: async (ctx, id) => {
            const data = {
                foreignCompetenceId: id,
            };
            await post('profile', 'competence/favorite/add', data, true);
        },

        removeFavoriteCompetence: async (ctx, id) => {
            const path = `competence/favorite/remove/${id}`;
            await get('profile', path);
            ctx.commit('deleteFavoriteCompetencies', id);
        },
    },
    getters: {
        userProfileId: state => state.userProfileInfo.id,
        userProfileInfo: state => state.userProfileInfo,
        getTelErrorMsg: state => state.telErrorMsg,
        getCoinsData: state => state.coinsData,
        hasLeader: state => state.hasLeader,
        userFavoriteCompetencies: state => state.userFavoriteCompetencies,
        getDataRequestRequareFields: state => state.dataRequestRequareFields,
        userProfileAge: state => {
            if (!state.userProfileInfo.dateOfBirth) {
                return null;
            }

            let now = new Date();
            let birthday = new Date(state.userProfileInfo.dateOfBirth);
            let age = now.getFullYear() - birthday.getFullYear();

            if (now.getMonth() < birthday.getMonth()) {
                age--;
            } else if (
                now.getMonth() === birthday.getMonth() &&
                now.getDate() < birthday.getDate()
            ) {
                age--;
            }
            return age;
        },
        userProfileName: state =>
            displayName([
                state.userProfileInfo.name,
                state.userProfileInfo.surname,
            ]),
        userAvatarUrl: state => state.avatars['avatar'] || null,
    },
};
